import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { ACORDO_ALADI_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    ACORDO_ALADI_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    ACORDO_ALADI_ENDPOINT,
    id
  ]);
}
